import {roomsEnumMap} from '@/utils/roomsMap';

type Props = {
  enumString: string;
  lang: string;
};

export default function RoomsEnumRoomType({enumString, lang}: Props) {
  const enumLabel = roomsEnumMap?.[enumString]?.[lang];

  return (
    <h5 className="mr-8 font-semibold mb-2 text-body">
      {enumLabel ? enumLabel : enumString}
    </h5>
  );
}
